import FormSelect from 'components/Select/FormSelect';
import { IItemForGetShortInfo, IGetSubCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { TCreateTeaserSelectedItem } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React, { useEffect } from 'react';
import { getSubCategoriesShortInfo } from 'backend/subcategories';

interface IDishSubCategorySelect {
	selectedTransitionDishCategory: TCreateTeaserSelectedItem;
	setTransitionDishSubCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
}

const DishSubCategorySelect: React.FC<IDishSubCategorySelect> = ({
	selectedTransitionDishCategory,
	setFetchedDishSubCategories,
	setTransitionDishSubCategory,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetSubCategoriesShort, string[]>(
		selectedTransitionDishCategory ? getSubCategoriesShortInfo : null,
		selectedTransitionDishCategory ? [selectedTransitionDishCategory] : [],
	);

	useEffect(() => {
		refetch();
	}, [selectedTransitionDishCategory]);

	useEffect(() => {
		response && setFetchedDishSubCategories(response.data.subCategories);
	}, [response]);
	return (
		<FormSelect
			testId="DishSubCategorySelect"
			name="selectedTransitionDishSubCategory"
			label="subcategoryLabel"
			disabled={!selectedTransitionDishCategory || loading}
			options={response?.data.subCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setTransitionDishSubCategory}
		/>
	);
};

export default React.memo(DishSubCategorySelect);
